import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme, { withChildren } = {}) => ({
  nestedCell: { padding: 0, borderBottom: 0, width: '90%' },
  collapsedRow: {
    boxShadow: withChildren
      ? '0px 0px 15px rgba(48, 85, 107, 0.14) !important'
      : '0px 5px 15px rgba(44, 112, 172, 0.2)',
    ...(withChildren && {
      borderRadius: '10px 10px 0px 0px !important',
      backgroundColor: theme.palette.lightGrey,
      '& td': {
        '&:first-child': {
          borderTopLeftRadius: 10,
        },
        '&:last-child': {
          borderTopRightRadius: 10,
        },
      },
    }),
  },
  collapsedTable: {
    width: '100%',
    '& tbody tr': {
      alignItems: 'center',
      display: 'flex',
      boxShadow: '0px 0px 1px rgba(48, 85, 107, 0.2)',
      '&:last-child': {
        borderRadius: '0px 0px 10px 10px',
        boxShadow: '0px 5px 17px rgba(48, 85, 107, 0.2)',
      },
      '& td': {
        alignItems: 'center',
        display: 'flex',
      },
    },
  },
}));
